import React from 'react'

const Skeleton = ({ className = '', ...props }) => {
    return (
        <div
            className={`
        animate-shimmer
        bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200
        dark:from-gray-800 dark:via-gray-700 dark:to-gray-800
        bg-[length:200%_100%]
        rounded-md
        ${className}
      `}
            {...props}
        />
    )
}

export default Skeleton
